import instance,{BASE_URL} from "../../services/api";

const ForgotPasswordViewController =()=>{

    const forgotPassword = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}forgot-password/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);

      dispatch({ type: "ADD_FORGOT_PASSWORD_EMAIL_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    //   toast.success("Announcement added sucessfully");
      return Promise.resolve(data); // ✅ return success
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "ADD_FORGOT_PASSWORD_EMAIL_FAILURE", payload: { error } });

      return Promise.reject(error); // ✅ return error
    }
  };
  
   const resetOtpPassword = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}reset-password/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);

      dispatch({ type: "ADD_RESET_PASSWORD_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    //   toast.success("Announcement added sucessfully");
      return Promise.resolve(data); // ✅ return success
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "ADD_RESET_PASSWORD_FAILURE", payload: { error } });

      return Promise.reject(error); // ✅ return error
    }
  };

   const resendOtp = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}resend-forgot-password-otp/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);

      dispatch({ type: "SEND_RESEND_OTP_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    //   toast.success("Announcement added sucessfully");
      return Promise.resolve(data); // ✅ return success
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "SEND_RESEND_OTP_FAILURE", payload: { error } });

      return Promise.reject(error); // ✅ return error
    }
  };

    return{ forgotPassword , resetOtpPassword,  resendOtp};
    
}

export default ForgotPasswordViewController